import axios, { AxiosInstance } from 'axios'
import {
	GetAvailableRsTimeSlotsParams,
	GetCosmeticsDataParams,
	GetSalonReviewsDataParams,
	GetSalonsDataForMapParams,
	GetSalonsDataParams,
	GetSalonsFilterCountsParams,
	AvailableRsTimeSlotsResponse,
	CategoriesResponse,
	CategoryResponse,
	ConfigResponse,
	CosmeticsResponse,
	GetSalonsFilterCountResponse,
	LanguagesResponse,
	MapPointsResponse,
	SalonResponse,
	SalonReviewsResponse,
	SalonServicesResponse,
	SalonsFilterResponse,
	SalonsResponse,
	CityByPlaceId,
	GetSalonFiltersQueryParams,
	PostCalendarEventsReservationBody,
	PostCalendarEventsReservationResponse,
	SalonServiceResponse,
	GetCalendarEventsReservationAvailableParams,
	GetCalendarEventsReservationAvailableResponse,
	GetCalendarEventsReservationFirstAvailableDateResponse,
	GetCalendarEventsReservationFirstAvailableDateParams,
	GetDocumentsDateParams,
	DocumentsResponse,
	PostSalonReviewRequestBody,
	PostSalonReviewResponse,
	GetFutureReservationsParams,
	FutureReservationsResponse,
	GetPastReservationsParams,
	PastReservationsResponse,
	GetPassesParams,
	PassesResponse,
	GetPassQrCodeParams,
	PassQrCodeResponse,
	PassResponse,
	GetReservationParams,
	ReservationResponse,
	PatchCancelCalendarEventsReservationBody,
	PatchCancelCalendarEventsReservationResponse,
	CustomConfig,
	SalonEmployeesParams,
	SalonEmployeesResponse,
	B2cApiEndpoint,
	LoyaltyConfigResponse,
	CitiesSeoSlugResponse,
	CitiesSeoSlugParams,
	CategoriesSeoSlugResponse,
	CategoriesSeoSlugParams,
	GetCartResponse,
	GetCartReservationsValidateResponse,
	GetPaginatedCalendarEventsGroupReservationAvailableParams,
	GetPaginatedCalendarEventsGroupReservationAvailableResponse,
	PostCartGroupReservationBody,
	PostCartGroupReservationResponse,
	PostCalendarEventsGroupReservationBody,
	PostCalendarEventsGroupReservationResponse,
	PostCartReservationBody,
	PostCartReservationResponse,
	PutCartReservationBody,
	PutCartReservationResponse,
	PutCartGroupReservationBody,
	PutCartGroupReservationResponse,
	DeleteCartReservationResponse,
	DeleteCartResponse,
	PatchCartBody,
	PatchCartResponse,
	PostCartSubmitBody,
	PostCartSubmitResponse
} from '../types/types'
import { SALON_TYPE, SALONS_PER_PAGE, SORTING_OPTION } from '../utils/enums'
import { deleteReq, getReq, patchReq, postReq, putReq } from '../utils/request'

const getSalonsDataParamsForRequest = (query: GetSalonsDataParams) => {
	const {
		page,
		limit = SALONS_PER_PAGE,
		openingHoursStatus,
		latMy,
		lonMy,
		lat,
		lon,
		categoryIDs,
		orderBy,
		exactRating,
		languageIDs,
		cosmeticIDs,
		hasAvailableReservationSystem: hasAvailableReservationSystemParam,
		// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
		// hasGift,
		serviceTotalPriceTo,
		serviceTotalPriceFrom,
		serviceTotalPriceCurrencyCode,
		avResTimeSlotDayPart,
		avResTimeSlotDate,
		avResTimeSlotDateFrom,
		avResTimeSlotDateTo
	} = query

	let createType: SALON_TYPE | undefined
	let order: string | undefined
	const hasAvailableReservationSystem: boolean | undefined = hasAvailableReservationSystemParam || undefined

	if (!orderBy || orderBy === SORTING_OPTION.RECOMMENDED) {
		createType = SALON_TYPE.NON_BASIC
		order = 'distance:asc'
	} else if (orderBy === SORTING_OPTION.CLOSEST) {
		order = 'distance:asc'
	} else if (orderBy === SORTING_OPTION.BEST_RATED) {
		order = 'rating:desc'
	} else if (orderBy === SORTING_OPTION.CHEAPEST) {
		order = 'priceLevel:asc'
	} else if (orderBy === SORTING_OPTION.MOST_EXPENSIVE) {
		order = 'priceLevel:desc'
	}

	const queryParams = {
		page,
		openingHoursStatus,
		latMy,
		lonMy,
		lat,
		lon,
		categoryIDs,
		createType,
		order,
		exactRating,
		limit,
		hasAvailableReservationSystem,
		// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
		// hasGift,
		serviceTotalPriceTo,
		serviceTotalPriceFrom,
		serviceTotalPriceCurrencyCode,
		languageIDs,
		cosmeticIDs,
		avResTimeSlotDayPart,
		avResTimeSlotDate,
		avResTimeSlotDateFrom,
		avResTimeSlotDateTo
	}
	return queryParams
}

const getSalonsData = async (query: GetSalonsDataParams, client: AxiosInstance, customConfig?: CustomConfig): Promise<SalonsResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/', { params: { query: getSalonsDataParamsForRequest(query) }, reqBody: {}, customConfig })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getSalonsFilterCounts = async (
	query: GetSalonsFilterCountsParams,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<GetSalonsFilterCountResponse> => {
	const { serviceTotalPriceCurrencyCode } = query
	const {
		openingHoursStatus,
		latMy,
		lat,
		lon,
		lonMy,
		categoryIDs,
		createType,
		exactRating,
		hasAvailableReservationSystem,
		// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
		// hasGift,
		serviceTotalPriceTo,
		serviceTotalPriceFrom,
		languageIDs,
		cosmeticIDs,
		avResTimeSlotDayPart,
		avResTimeSlotDate,
		avResTimeSlotDateFrom,
		avResTimeSlotDateTo
	} = getSalonsDataParamsForRequest(query)

	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/filter/counts', {
			params: {
				query: {
					openingHoursStatus,
					lat,
					lon,
					latMy,
					lonMy,
					categoryIDs,
					createType,
					exactRating,
					hasAvailableReservationSystem,
					// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
					// hasGift,
					serviceTotalPriceTo,
					serviceTotalPriceFrom,
					serviceTotalPriceCurrencyCode,
					languageIDs,
					cosmeticIDs,
					avResTimeSlotDayPart,
					avResTimeSlotDate,
					avResTimeSlotDateFrom,
					avResTimeSlotDateTo
				}
			},
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonsDataForMap = async (
	query: GetSalonsDataForMapParams,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<MapPointsResponse | undefined> => {
	const {
		openingHoursStatus,
		latMy,
		lonMy,
		categoryIDs,
		createType,
		exactRating,
		hasAvailableReservationSystem,
		// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
		// hasGift,
		serviceTotalPriceTo,
		serviceTotalPriceFrom,
		serviceTotalPriceCurrencyCode,
		languageIDs,
		cosmeticIDs,
		avResTimeSlotDayPart,
		avResTimeSlotDate,
		avResTimeSlotDateFrom,
		avResTimeSlotDateTo
	} = getSalonsDataParamsForRequest(query)

	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/map', {
			params: {
				query: {
					openingHoursStatus,
					categoryIDs,
					exactRating,
					createType,
					hasAvailableReservationSystem,
					// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
					// hasGift,
					serviceTotalPriceFrom,
					serviceTotalPriceTo,
					serviceTotalPriceCurrencyCode,
					languageIDs,
					cosmeticIDs,
					avResTimeSlotDayPart,
					avResTimeSlotDate,
					avResTimeSlotDateFrom,
					avResTimeSlotDateTo,
					latMy,
					lonMy,
					latNW: query.latNW,
					lonNW: query.lonNW,
					latSE: query.latSE,
					lonSE: query.lonSE
				}
			},
			reqBody: {},
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonsFilterData = async (query: GetSalonFiltersQueryParams, client: AxiosInstance): Promise<SalonsFilterResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/filter/', { params: { query }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonData = async (seoSlugName: string, client: AxiosInstance, customConfig?: CustomConfig): Promise<SalonResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/by-seo-slugname/{seoSlugName}', {
			params: { path: { seoSlugName } },
			reqBody: {},
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonServicesData = async (salonID: string, client: AxiosInstance): Promise<SalonServicesResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/services', { params: { path: { salonID } }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const REVIEWS_LIMIT = 3
const getSalonReviewsData = async (salonID: string, params: GetSalonReviewsDataParams, client: AxiosInstance): Promise<SalonReviewsResponse> => {
	try {
		const queryParams = {
			page: params.page,
			limit: REVIEWS_LIMIT
		}
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/reviews/', { params: { query: queryParams, path: { salonID } }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCategoriesData = async (client: AxiosInstance): Promise<CategoriesResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/enums/categories/', { params: {}, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCategoryData = async (categoryID: string, client: AxiosInstance): Promise<CategoryResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/enums/categories/{categoryID}', { params: { path: { categoryID } }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getConfigData = async (client: AxiosInstance): Promise<ConfigResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/config/', { params: {}, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getLoyaltyConfigData = async (client: AxiosInstance, customConfig?: CustomConfig): Promise<LoyaltyConfigResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/config/loyalty', { params: {}, reqBody: {}, customConfig })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCosmeticsData = async (query: GetCosmeticsDataParams, client: AxiosInstance): Promise<CosmeticsResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/enums/cosmetics/', { params: { query }, reqBody: {}, customConfig: { allowAbort: true } })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getLanguagesData = async (client: AxiosInstance): Promise<LanguagesResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/enums/languages/', { params: {}, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getAvailableReservationTimeSlotsData = async (
	query: GetAvailableRsTimeSlotsParams,
	client: AxiosInstance
): Promise<AvailableRsTimeSlotsResponse | undefined> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/filter/available-reservation-time-slots', { params: { query }, reqBody: {} })
		return data
	} catch (_error) {
		return undefined
	}
}

export const getCityNameByPlaceId = async (placeId: string, client: AxiosInstance): Promise<CityByPlaceId | undefined> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/filter/cities/{placeID}', { params: { path: { placeID: placeId } }, reqBody: {} })
		return data.city
	} catch (_error) {
		return undefined
	}
}

export const postCalendarEventsReservation = async (
	salonID: string,
	reqBody: PostCalendarEventsReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostCalendarEventsReservationResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/salons/{salonID}/calendar-events/reservations/', {
			params: { path: { salonID } },
			reqBody,
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const postCalendarEventsGroupReservation = async (
	salonID: string,
	reqBody: PostCalendarEventsGroupReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostCalendarEventsGroupReservationResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/salons/{salonID}/calendar-events/group/reservations/', {
			params: { path: { salonID } },
			reqBody,
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const postCartReservations = async (
	deviceID: string,
	reqBody: PostCartReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostCartReservationResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/cart/reservations/', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const putCartReservation = async (
	deviceID: string,
	reqBody: PutCartReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PutCartReservationResponse> => {
	try {
		const { data } = await putReq(client, '/api/b2c/web/cart/reservations/', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const putCartGroupReservation = async (
	deviceID: string,
	reqBody: PutCartGroupReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PutCartGroupReservationResponse> => {
	try {
		const { data } = await putReq(client, '/api/b2c/web/cart/reservations/group/', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const postCartGroupReservations = async (
	deviceID: string,
	reqBody: PostCartGroupReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostCartGroupReservationResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/cart/reservations/group/', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const postCartSubmit = async (
	deviceID: string,
	reqBody: PostCartSubmitBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostCartSubmitResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/cart/submit', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCart = async (deviceID: string, client: AxiosInstance, customConfig?: CustomConfig): Promise<GetCartResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/cart/', {
			params: {},
			reqBody: {},
			customConfig: {
				...customConfig,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCartReservationsValidate = async (
	deviceID: string,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<GetCartReservationsValidateResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/cart/reservations/validate', {
			params: {},
			reqBody: {},
			customConfig: {
				...customConfig,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const deleteCart = async (deviceID: string, client: AxiosInstance, customConfig?: CustomConfig): Promise<DeleteCartResponse> => {
	try {
		const { data } = await deleteReq(client, '/api/b2c/web/cart/', {
			params: {},
			reqBody: {},
			customConfig: {
				...customConfig,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const deleteCartReservation = async (
	deviceID: string,
	cartReservationItemID: string,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<DeleteCartReservationResponse> => {
	try {
		const { data } = await deleteReq(client, '/api/b2c/web/cart/reservations/{cartReservationItemID}', {
			params: { path: { cartReservationItemID } },
			reqBody: {},
			customConfig: {
				...customConfig,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonServiceData = async (serviceID: string, client: AxiosInstance): Promise<SalonServiceResponse | undefined> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/services/{serviceID}', { params: { path: { serviceID } }, reqBody: {} })
		return data
	} catch (_error) {
		return undefined
	}
}

export const getCalendarEventsReservationAvailableParamsSlots = async (
	salonID: string,
	query: GetCalendarEventsReservationAvailableParams,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<GetCalendarEventsReservationAvailableResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/calendar-events/reservations/available', {
			params: {
				path: { salonID },
				query
			},
			reqBody: {},
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getPaginatedCalendarEventsGroupReservationAvailable = async (
	salonID: string,
	query: GetPaginatedCalendarEventsGroupReservationAvailableParams,
	client: AxiosInstance,
	deviceID?: string,
	customConfig?: CustomConfig
): Promise<GetPaginatedCalendarEventsGroupReservationAvailableResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/calendar-events/group/reservations/available/paginated', {
			params: {
				path: { salonID },
				query
			},
			reqBody: {},
			customConfig: {
				...customConfig,
				headers: {
					...customConfig?.headers,
					...(deviceID ? { 'device-id': deviceID } : {})
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCalendarEventsReservationFirstAvailableDate = async (
	salonID: string,
	query: GetCalendarEventsReservationFirstAvailableDateParams,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<GetCalendarEventsReservationFirstAvailableDateResponse | undefined> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/calendar-events/reservations/first-available-date', {
			params: {
				path: { salonID },
				query
			},
			reqBody: {},
			customConfig
		})
		return data
	} catch (error) {
		if (axios.isAxiosError(error) && error.code === 'ERR_CANCELED') {
			return Promise.reject(error)
		}

		return undefined
	}
}

export const getDocuments = async (
	client: AxiosInstance,
	query: GetDocumentsDateParams,
	customConfig?: CustomConfig
): Promise<DocumentsResponse | undefined> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/documents/', { params: { query }, reqBody: {}, customConfig })
		return data
	} catch (_error) {
		return undefined
	}
}

export const postSalonReview = async (
	salonID: string,
	reqBody: PostSalonReviewRequestBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PostSalonReviewResponse> => {
	try {
		const { data } = await postReq(client, '/api/b2c/web/salons/{salonID}/reviews/', {
			params: { path: { salonID } },
			reqBody,
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getFutureReservations = async (client: AxiosInstance, query: GetFutureReservationsParams): Promise<FutureReservationsResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/calendar-events/reservations/future', { params: { query }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getPastReservations = async (client: AxiosInstance, query: GetPastReservationsParams): Promise<PastReservationsResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/calendar-events/reservations/past', { params: { query }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getPasses = async (client: AxiosInstance, query: GetPassesParams): Promise<PassesResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/passes/', { params: { query }, reqBody: {} })
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getPassData = async (client: AxiosInstance, passID: string, customConfig?: CustomConfig): Promise<PassResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/passes/{passID}', {
			params: { path: { passID } },
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getPassQrCode = async (
	client: AxiosInstance,
	passID: string,
	query?: GetPassQrCodeParams,
	customConfig?: CustomConfig
): Promise<PassQrCodeResponse> => {
	try {
		const { data } = await getReq<'/api/b2c/web/passes/{passID}/qr-code', PassQrCodeResponse>(client, '/api/b2c/web/passes/{passID}/qr-code', {
			params: { path: { passID }, query },
			reqBody: {},
			customConfig: {
				...customConfig,
				responseType: 'blob'
			}
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getReservationData = async (
	client: AxiosInstance,
	reservationID: string,
	query?: GetReservationParams,
	customConfig?: CustomConfig
): Promise<ReservationResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/calendar-events/reservations/{reservationID}', {
			params: { path: { reservationID }, query },
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const patchCart = async (deviceID: string, reqBody: PatchCartBody, client: AxiosInstance, customConfig?: CustomConfig): Promise<PatchCartResponse> => {
	try {
		const { data } = await patchReq(client, '/api/b2c/web/cart/', {
			params: {},
			reqBody,
			customConfig: {
				...customConfig,
				displayNotification: false,
				headers: {
					...customConfig?.headers,
					'device-id': deviceID
				}
			}
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

export const patchCalendarEventsReservationCancel = async (
	reservationID: string,
	reqBody: PatchCancelCalendarEventsReservationBody,
	client: AxiosInstance,
	customConfig?: CustomConfig
): Promise<PatchCancelCalendarEventsReservationResponse> => {
	try {
		const { data } = await patchReq(client, '/api/b2c/web/calendar-events/reservations/{reservationID}/cancel', {
			params: { path: { reservationID } },
			reqBody,
			customConfig
		})
		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getSalonEmployees = async (
	client: AxiosInstance,
	salonID: string,
	query?: SalonEmployeesParams,
	customConfig?: CustomConfig
): Promise<SalonEmployeesResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/salons/{salonID}/employees', {
			params: { path: { salonID }, query },
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getCitiesSeoSlugData = async (
	client: AxiosInstance,
	seoSlug: string,
	query: CitiesSeoSlugParams,
	customConfig?: CustomConfig
): Promise<CitiesSeoSlugResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/cities/slug/{seoSlug}', {
			params: { path: { seoSlug }, query },
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const getCategoriesSeoSlugData = async (
	client: AxiosInstance,
	seoSlug: string,
	query: CategoriesSeoSlugParams,
	customConfig?: CustomConfig
): Promise<CategoriesSeoSlugResponse> => {
	try {
		const { data } = await getReq(client, '/api/b2c/web/enums/categories/slug/{seoSlug}', {
			params: { path: { seoSlug }, query },
			reqBody: {},
			customConfig
		})

		return data
	} catch (error) {
		return Promise.reject(error)
	}
}

const loadApiEndpoints = (client: AxiosInstance): B2cApiEndpoint => {
	return {
		// Get requests
		getSalonData: (seoSlugName, customConfig) => getSalonData(seoSlugName, client, customConfig),
		getSalonEmployees: (salonID, query, customConfig) => getSalonEmployees(client, salonID, query, customConfig),
		getSalonsDataForMap: (params, customConfig) => getSalonsDataForMap(params, client, customConfig),
		getSalonsFilterCounts: (params, customConfig) => getSalonsFilterCounts(params, client, customConfig),
		getSalonServicesData: (salonID) => getSalonServicesData(salonID, client),
		getSalonServiceData: (serviceID) => getSalonServiceData(serviceID, client),
		getSalonReviewsData: (salonID, params) => getSalonReviewsData(salonID, params, client),
		getSalonsData: (params, customConfig) => getSalonsData(params, client, customConfig),
		getCategoriesData: () => getCategoriesData(client),
		getCategoryData: (categoryID) => getCategoryData(categoryID, client),
		getSalonsFilterData: (query) => getSalonsFilterData(query, client),
		getConfigData: () => getConfigData(client),
		getLoyaltyConfigData: (customConfig) => getLoyaltyConfigData(client, customConfig),
		getCosmeticsData: (params) => getCosmeticsData(params, client),
		getLanguagesData: () => getLanguagesData(client),
		getAvailableReservationTimeSlotsData: (params) => getAvailableReservationTimeSlotsData(params, client),
		getCityNameByPlaceId: (placeId) => getCityNameByPlaceId(placeId, client),
		getCalendarEventsReservationAvailableParamsSlots: (salonID, query, customConfig) =>
			getCalendarEventsReservationAvailableParamsSlots(salonID, query, client, customConfig),
		getPaginatedCalendarEventsGroupReservationAvailable: (salonID, query, deviceID, customConfig) =>
			getPaginatedCalendarEventsGroupReservationAvailable(salonID, query, client, deviceID, customConfig),
		getCalendarEventsReservationFirstAvailableDate: (salonID, query, customConfig) =>
			getCalendarEventsReservationFirstAvailableDate(salonID, query, client, customConfig),
		getDocuments: (query, customConfig) => getDocuments(client, query, customConfig),
		getFutureReservations: (query) => getFutureReservations(client, query),
		getPastReservations: (query) => getPastReservations(client, query),
		getPasses: (query) => getPasses(client, query),
		getPassData: (passID, customConfig) => getPassData(client, passID, customConfig),
		getPassQrCode: (passID, query, customConfig) => getPassQrCode(client, passID, query, customConfig),
		getReservationData: (reservationID, query, customConfig) => getReservationData(client, reservationID, query, customConfig),
		getCategoriesSeoSlugData: (categorySeoSlug, query, customConfig) => getCategoriesSeoSlugData(client, categorySeoSlug, query, customConfig),
		getCitiesSeoSlugData: (citySeoSlug, query, customConfig) => getCitiesSeoSlugData(client, citySeoSlug, query, customConfig),
		getCart: (deviceID, customConfig) => getCart(deviceID, client, customConfig),
		getCartReservationsValidate: (deviceID, customConfig) => getCartReservationsValidate(deviceID, client, customConfig),
		deleteCart: (deviceID, customConfig) => deleteCart(deviceID, client, customConfig),
		deleteCartReservation: (deviceID, cartReservationItemID, customConfig) => deleteCartReservation(deviceID, cartReservationItemID, client, customConfig),
		// Post requests
		postCalendarEventsReservation: (salonID, reqBody, customConfig) => postCalendarEventsReservation(salonID, reqBody, client, customConfig),
		postCalendarEventsGroupReservation: (salonID, reqBody, customConfig) => postCalendarEventsGroupReservation(salonID, reqBody, client, customConfig),
		postCartReservations: (deviceID, reqBody, customConfig) => postCartReservations(deviceID, reqBody, client, customConfig),
		putCartReservation: (deviceID, reqBody, customConfig) => putCartReservation(deviceID, reqBody, client, customConfig),
		putCartGroupReservation: (deviceID, reqBody, customConfig) => putCartGroupReservation(deviceID, reqBody, client, customConfig),
		postCartGroupReservations: (deviceID, reqBody, customConfig) => postCartGroupReservations(deviceID, reqBody, client, customConfig),
		postCartSubmit: (deviceID, reqBody, customConfig) => postCartSubmit(deviceID, reqBody, client, customConfig),
		postSalonReview: (salonID, reqBody, customConfig) => postSalonReview(salonID, reqBody, client, customConfig),
		// patch requests
		patchCart: (deviceID, reqBody, customConfig) => patchCart(deviceID, reqBody, client, customConfig),
		patchCalendarEventsReservationCancel: (reservationID, reqBody, customConfig) =>
			patchCalendarEventsReservationCancel(reservationID, reqBody, client, customConfig)
	}
}

export default loadApiEndpoints
